module.exports = __webpack_public_path__ + "static/logo-sm-bd1e6fa73a37504270f1125125272c8f.png";